import React from 'react'

const ExternalLinkApprovalTemplate = ({ data }) => {
  const {
    studentName,
    roleName,
    companyName,
    deadlineDate,
    placementOfficerName,
    placementOfficerContact
  } = data

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      <p>Dear {studentName},</p>
      
      <p style={{ paddingTop: '8px' }}>
        Your request to apply for the {roleName} role at {companyName} has been approved. 
        Please ensure you submit your application before the deadline on {deadlineDate}.
      </p>
      
      <p style={{ paddingTop: '8px' }}>
        If you need assistance or have any queries during the application process, feel free to reach out.
      </p>
      
      <p style={{ paddingTop: '8px' }}>
        Wishing you the best of luck!
      </p>
      
      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>Best regards,</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{placementOfficerName}</p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>{placementOfficerContact}</p>
    </div>
  )
}

export default ExternalLinkApprovalTemplate
